import { Component, inject, signal } from '@angular/core';
import { form, FormField, validate } from '@angular/forms/signals';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { UiInputComponent } from '@app/shared/ui/input/ui-input.component';
import { TranslatePipe } from '@ngx-translate/core';

export interface FileExplorerNameDialogData {
  title: string;
  name?: string;
  extension?: string;
}

/** Receives a name and returns a validated choice; the caller owns all writes. */
@Component({
  selector: 'proffeo-file-explorer-name-dialog',
  templateUrl: './file-explorer-name-dialog.component.html',
  imports: [FormField, MatDialogModule, TranslatePipe, UiDialogComponent, UiInputComponent, UiButtonComponent]
})
export class FileExplorerNameDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<FileExplorerNameDialogComponent, string>);
  protected readonly data = inject<FileExplorerNameDialogData>(MAT_DIALOG_DATA);
  protected readonly model = signal({ name: this.data.name ?? '' });
  protected readonly nameForm = form(this.model, path => {
    validate(path.name, ({ value }) => {
      const name = value().trim();
      const hasControl = [...name].some(
        character => character.charCodeAt(0) < 32 || (character.charCodeAt(0) >= 127 && character.charCodeAt(0) <= 159)
      );
      const dot = name.lastIndexOf('.');
      const extension = dot >= 0 && dot < name.length - 1 ? name.slice(dot) : '';
      if (this.data.extension !== undefined && extension !== this.data.extension) {
        return { kind: 'extension', message: 'files.explorer.extension-unchanged' };
      }
      return !name ||
        name.length > 255 ||
        name === '.' ||
        name === '..' ||
        name.includes('/') ||
        name.includes('\\') ||
        hasControl
        ? { kind: 'name', message: 'files.explorer.invalid-name' }
        : undefined;
    });
  });

  protected save(event?: Event): void {
    event?.preventDefault();
    if (this.nameForm().invalid()) return;
    this.dialogRef.close(this.model().name.trim());
  }
}
